'use client';
import { useIsScreen } from '@/app/hooks';
import { playMediaSafely } from '@/app/utils/client';
import type { VideoResource } from '../constants';
import PosterGroup from './PosterGroup';

interface CarouselItemProps extends VideoResource {
  isSelected: boolean;
}

/**
 * 轮播项组件，包含视频和海报显示
 */
export const CarouselItem = ({ url, poster, poster1, mobilePoster1, isSelected }: CarouselItemProps) => {
  const { isMdScreen } = useIsScreen();
  const currentPoster = isMdScreen && mobilePoster1 ? mobilePoster1 : poster1;

  const videoRef = (el: HTMLVideoElement | null) => {
    if (el && isSelected) {
      playMediaSafely(el);
    }
  };

  const mirrorVideoRef = (el: HTMLVideoElement | null) => {
    if (el && isSelected) {
      playMediaSafely(el);
    }
  };

  return (
    <div className="flex w-full flex-col">
      {/* 视频容器 */}
      <div className="relative w-full">
        {/* 主视频元素 */}
        <video
          id={`video-${poster1}`}
          controls={false}
          poster={isSelected ? currentPoster : undefined}
          muted
          playsInline
          preload={isSelected ? 'metadata' : 'none'}
          webkit-playsinline="true"
          x5-playsinline="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="false"
          className="aspect-video w-full rounded-12 object-cover object-center md:rounded-none"
          ref={videoRef}
        >
          {isSelected && <source src={url} type="video/mp4" />}
        </video>

        {poster.length > 0 && (
          <div className="absolute right-0 bottom-[110px] left-0 z-10 md:bottom-10">
            <div className="flex flex-col items-center justify-center">
              {/* 主要内容 */}
              <div className="flex items-center justify-center gap-1 rounded-16 bg-system-black64 p-3 backdrop-blur-[30px] md:gap-[2px] md:rounded-[6px] md:p-[5px]">
                <PosterGroup poster={poster} />
              </div>
            </div>
            {/* 镜像投影效果 */}
            <div className="absolute top-0 z-10 flex w-full origin-bottom scale-y-[-1] items-center justify-center blur-[8px]">
              <div className="flex items-center justify-center gap-1 rounded-4 p-3 md:gap-[2px] md:rounded-[3px] md:p-[5px]">
                <PosterGroup poster={poster} />
              </div>
            </div>
          </div>
        )}

        {/* 镜像投影效果 */}
        {poster.length > 0 && (
          <div className="relative h-40 w-full md:h-16">
            {/* 视频镜像元素 */}
            <div className="relative z-0 h-full w-full overflow-hidden opacity-[0.48]">
              <video
                controls={false}
                poster={isSelected ? currentPoster : undefined}
                muted
                playsInline
                preload={isSelected ? 'metadata' : 'none'}
                webkit-playsinline="true"
                x5-playsinline="true"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="false"
                className="w-full scale-y-[-1] blur-[30px] md:blur-[15px]"
                ref={mirrorVideoRef}
              >
                {isSelected && <source src={url} type="video/mp4" />}
              </video>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
